import { OneConfig } from '@yy/one-config'
import { sentryReport } from './http'

export const oneConfig = new OneConfig({
  env: process.env.APP_ENV,
  priority: process.env.REGION === 'oss' ? ['oss', 's3'] : ['s3', 'oss'],
  onError: sentryReport,
})
